
<template>
  <div v-if="isShowModal && src" class="expired-modal">
    <div class="modal-wrap">
      <img class="img" :src="src" />
      <div class="btn" @click="handleGetCoupon" />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({})
export default class CouponModal extends Vue {
  @Prop({ default: '' }) src!: string;
  @Prop({ default: 0 }) productionId!: number;

  isShowModal = false;

  toggleModal(status: boolean) {
    this.isShowModal = status;
  }

  async handleGetCoupon() {
    try {
      const { data } = await window.apis.getCoupon({
        code: this.$route.query.code,
        production_id: Number(this.$route.params.id),
      });
      this.toggleModal(false);
      this.$emit('getCouponSuccess');
    } catch (error) {
      console.log(error);
    }
  }
}
</script>

<style lang="scss" scoped>
.expired-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  width: 100vw;
  height: 100vh;
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
  background-color: rgba(1, 1, 1, 0.8);

  .modal-wrap {
    position: relative;
    .img {
      width: 100vw;
      height: 920px;
    }
    .btn {
      position: absolute;
      bottom: 94px;
      left: 50%;
      width: 320px;
      height: 96px;
      transform: translateX(-50%);
    }
  }
}
</style>